import { Link } from "react-router-dom";
import { ArrowRight, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { Progress } from "@/components/ui/progress";
import { api, TIPOS, fmtDate, fmtEur } from "@/lib/api";
import { useAuth, puedeEco } from "@/lib/auth";
import { EstadoBadge } from "@/components/Badges";
import { Section } from "@/components/Fields";
import { NewTreatmentDialog } from "@/components/NewTreatmentDialog";

const Card = ({ t, onChange }) => {
  const isAdmin = puedeEco(useAuth().user);
  const T = TIPOS[t.tipo];
  const pct = t.total ? Math.round((t.realizadas / t.total) * 100) : 0;
  const remove = async (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (!window.confirm(`¿Eliminar ${T.single}${t.bono_num ? ` nº ${t.bono_num}` : ""}? Se borrarán sus citas y pagos.${t.device_id ? ` El aparato ${t.aparato} quedará libre.` : ""}`)) return;
    await api.delete(`/treatments/${t.id}`);
    toast.success("Tratamiento eliminado");
    onChange?.();
  };
  return (
    <Link to={`/tratamiento/${t.id}`} state={{ desdePaciente: true }} data-testid={`patient-treatment-${t.tipo}`} className="lift block border border-slate-200 rounded-md p-3 hover:border-slate-300">
      <div className="flex items-center gap-2">
        <div className="h-7 w-7 rounded grid place-items-center" style={{ background: `${T.dot}14`, color: T.dot }}><T.icon className="h-4 w-4" /></div>
        <span className="font-medium text-sm text-slate-900">{T.single}{t.bono_num ? ` nº ${t.bono_num}` : ""}</span>
        <EstadoBadge estado={t.estado} />
        {t.bono_num && <span data-testid={`patient-bonos-total-${t.id}`} className="text-[11px] text-indigo-700 font-semibold">lleva {t.bonos_total}</span>}
        <button type="button" onClick={remove} data-testid={`delete-patient-treatment-${t.id}`} title="Eliminar tratamiento"
          className="ml-auto h-7 w-7 grid place-items-center rounded text-slate-400 hover:text-rose-600 hover:bg-rose-50 transition-colors"><Trash2 className="h-4 w-4" /></button>
        <ArrowRight className="h-4 w-4 text-slate-300" />
      </div>
      <div className="mt-3 flex items-center gap-2">
        <Progress value={pct} className="h-1.5" />
        <span className="font-[JetBrains_Mono] text-xs text-slate-500 whitespace-nowrap">{t.realizadas}/{t.total}</span>
      </div>
      <div className="mt-2 flex justify-between text-xs text-slate-500">
        <span>Próx.: {fmtDate(t.proxima_cita)}</span>
        {isAdmin && <span>Pagado {fmtEur(t.pagado)}{t.pendiente_pago > 0 && <b className="text-amber-700"> · debe {fmtEur(t.pendiente_pago)}</b>}</span>}
      </div>
    </Link>
  );
};

export const PatientTreatments = ({ patientId, treatments, onChange }) => (
  <Section title="Tratamientos" testId="sec-tratamientos"
    action={<NewTreatmentDialog patientId={patientId} onCreated={onChange} triggerLabel="Añadir" />}>
    <div className="space-y-2">
      {treatments.length === 0 && <p className="text-sm text-slate-400" data-testid="no-treatments">Aún sin tratamientos. Se crearán al marcar la respuesta como APROBADO.</p>}
      {treatments.map((t) => <Card key={t.id} t={t} onChange={onChange} />)}
    </div>
  </Section>
);
